import type {
  QuoteInquiryDetail,
  QuoteInquiryPageResponse,
  QuoteInquiryStatus,
  ReplyQuoteInquiryRequest,
  UpdateQuoteInquiryStatusRequest,
} from "../../types/quote-inquiry";
import type { CompanyQuoteInquiryRepository } from "../../../infrastructure/repositories/company/company-quote-inquiry-repository-impl";

export class CompanyQuoteInquiryUseCase {
  constructor(private repository: CompanyQuoteInquiryRepository) {}

  /**
   * 견적 문의 목록 조회
   */
  async getQuoteInquiries(params: {
    companyId: number;
    status?: QuoteInquiryStatus;
    keyword?: string;
    page?: number;
    size?: number;
  }): Promise<QuoteInquiryPageResponse> {
    return this.repository.getQuoteInquiries(params.companyId, {
      status: params.status,
      keyword: params.keyword,
      page: params.page,
      size: params.size,
    });
  }

  /**
   * 견적 문의 상세 조회
   */
  async getQuoteInquiry(params: {
    companyId: number;
    inquiryId: number;
  }): Promise<QuoteInquiryDetail> {
    return this.repository.getQuoteInquiry(params.companyId, params.inquiryId);
  }

  /**
   * 견적 문의 답변 발송
   */
  async replyQuoteInquiry(params: {
    companyId: number;
    inquiryId: number;
    request: ReplyQuoteInquiryRequest;
  }): Promise<QuoteInquiryDetail> {
    return this.repository.replyQuoteInquiry(
      params.companyId,
      params.inquiryId,
      params.request
    );
  }

  /**
   * 견적 문의 상태 변경
   */
  async updateQuoteInquiryStatus(params: {
    companyId: number;
    inquiryId: number;
    status: QuoteInquiryStatus;
  }): Promise<QuoteInquiryDetail> {
    const request: UpdateQuoteInquiryStatusRequest = {
      status: params.status,
    };
    return this.repository.updateQuoteInquiryStatus(
      params.companyId,
      params.inquiryId,
      request
    );
  }
}
